import React from 'react';
import { Text, View } from 'react-native';

//= ========================================================================

const ParticipantDivisionComponent = ({
  globJSON,
  totalAmount,
  numberOfParticipants,
  totalAmountText,

}) => {
  const { colors } = globJSON.configurations.theme;
  const myStyles = {
    center: {
      alignItems: 'center',
      justifyContent: 'center',
    },
    largeText: {
      fontSize: 21,
      color: colors.primary_font_color,
    },
    smallText: {
      fontSize: 12,
      color: colors.primary_font_color,
    },
    row: {
      flexDirection: 'row',
      alignItems: 'end',
    },
    greyLine: {
      width: 88,
      height: 1,
      backgroundColor: colors.border_color,
    },
    smallGreyText: {
      fontSize: 9,
      color: colors.primary_font_color,
    },

  };

  return (
    <View style={myStyles.center}>
      <View style={myStyles.row}>
        <Text style={myStyles.largeText}>{`$${Math.ceil(totalAmount / numberOfParticipants)}`}</Text>
        <Text style={myStyles.smallText}>{`x${numberOfParticipants}`}</Text>
      </View>
      <View style={myStyles.greyLine} />
      <Text style={myStyles.smallGreyText}>{`${totalAmountText}: $${totalAmount}`}</Text>
    </View>
  );
};
export default ParticipantDivisionComponent;
